import { Controller } from "@hotwired/stimulus"

// The Ideas planner's side drawer. Closing empties the Turbo Frame rather than
// navigating, so the board behind it is never reloaded and never loses scroll.
export default class extends Controller {
  connect() {
    // Move focus into the drawer so Escape and tabbing land somewhere sensible
    // for anyone who opened it from the keyboard.
    this.element.setAttribute("tabindex", "-1")
    this.element.focus({ preventScroll: true })
  }

  close() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return

    // Clicking a chip leaves a collapsed text selection anchored inside that
    // link. A selection inside a drag source makes the browser try to drag the
    // selection rather than the element, and a zero-width one drags nothing at
    // all, so the chip that opened the drawer would sit there refusing to move
    // until a click elsewhere moved the selection off it.
    this.releaseSelection()

    frame.removeAttribute("src")
    frame.innerHTML = ""
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }

  // Clicking the board behind the drawer dismisses it. The drawer is not modal
  // on purpose (the board stays readable and clickable), so a click on another
  // chip still opens that idea rather than being swallowed as a dismissal.
  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) return
    // A click on another card opens that idea instead of being swallowed as a
    // dismissal. The guard follows the cards: they used to be anchors carrying
    // data-turbo-frame, and when that went away this kept looking for it, so
    // every card click both closed the drawer and reopened it, racing Turbo
    // mid-navigation.
    if (event.target.closest("[data-ideas-plan-target~='draggable']")) return

    this.close()
  }

  releaseSelection() {
    const selection = window.getSelection()
    if (selection && selection.isCollapsed) selection.removeAllRanges()

    if (document.activeElement instanceof HTMLElement) document.activeElement.blur()
  }
}
